define('Facets.ItemCell.View.Extension', ['Facets.ItemCell.View', 'underscore'], function (
  FacetsItemCellView,
  _
) {
  'use strict';

  return _.extend(FacetsItemCellView.prototype, {
    getContext: _.wrap(FacetsItemCellView.prototype.getContext, function (fn, args) {
      var context = fn.apply(this, _.toArray(arguments).slice(1));

      return _.extend(context, {
        storedescription: this.model.get('storedescription'),
      });
    }),
  });
});
